import { generators } from '@/components/shared/generators/generators';

// Function to return if a style is SDXL
export function isSDXL(style: string): boolean {
  // Style is shortname
  const generator = generators.find((g) => g.shortName === style);
  return generator?.isSDXL ?? false;
}
